import React from "react";
import { twMerge } from "tailwind-merge";

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
}

export function Label({ htmlFor, children, className = "", ...props }: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(
        "mb-1.5 block text-sm font-medium text-text-primary dark:text-gray-300",
        className,
      )}
      {...props}
    >
      {children}
    </label>
  );
}

export default Label;
